module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/th/5-3f1e5f42eccb2f326eba61ec8dc71fb9.jpg";